import { useMemo } from 'react';
import { useMeContext } from 'modules/me';

interface UseTimePickerResultProps {
  ampm: boolean;
  mask: string;
  inputFormat?: string;
}

export const useTimePickerProps = (): UseTimePickerResultProps => {
  const { locale } = useMeContext() ?? {};
  return useMemo(() => {
    const timeFormat = locale?.dateTimeSettings?.shortTimeFormat?.luxonPattern;

    // eslint-disable-next-line quotes
    if (timeFormat === "h':'mm a") {
      return {
        inputFormat: 'hh:mm a',
        ampm: true,
        mask: '__:__ _M'
      };
    }

    return {
      inputFormat: 'hh:mm',
      ampm: false,
      mask: '__:__'
    };
  }, [locale?.dateTimeSettings?.shortTimeFormat?.luxonPattern]);
};
